// extracted by mini-css-extract-plugin
export default {"wrapper":"attachment-field_wrapper__dnm8F","attachmentField":"attachment-field_attachmentField__6oo1J","disabled":"attachment-field_disabled__v4vj1"};